// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.features { 
  background: #ffffff; 
  padding: 80px 0;
}

.features-grid { 
  display: grid; 
  grid-template-columns: repeat(5, 1fr); 
  gap: 16px; 
  max-width: 1400px;
  margin: 0 auto;
}

.feature-card { 
  background: #fff; 
  border-radius: 12px; 
  padding: 20px 16px; 
  border: 1px solid #edf2f7; 
  box-shadow: 0 4px 12px rgba(0,0,0,.04); 
  transition: all .25s ease; 
  text-align: center;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.feature-card:hover { 
  transform: translateY(-6px); 
  box-shadow: 0 12px 32px rgba(158,37,54,.15);
  border-color: rgba(158,37,54,.2);
}

.feature-card h3 { 
  margin: 12px 0 10px; 
  color: #2d3748; 
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-card p { 
  color: #4a5568; 
  line-height: 1.5; 
  font-size: 0.85rem;
  flex-grow: 1;
  margin: 0;
}

.feature-icon { 
  font-size: 2.2rem; 
  margin-bottom: 8px;
  display: block;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  
  .feature-card {
    min-height: 320px;
    padding: 24px 20px;
  }
  
  .feature-card h3 {
    font-size: 1.1rem;
    min-height: 48px;
  }
  
  .feature-card p {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .feature-card {
    min-height: auto;
    padding: 24px;
  }
  
  .feature-card h3 {
    font-size: 1.2rem;
    min-height: auto;
  }
  
  .feature-card p {
    font-size: 1rem;
    line-height: 1.6;
  }
  
  .feature-icon {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .features {
    padding: 60px 0;
  }
  
  .feature-card {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Features.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".features { \n  background: #ffffff; \n  padding: 80px 0;\n}\n\n.features-grid { \n  display: grid; \n  grid-template-columns: repeat(5, 1fr); \n  gap: 16px; \n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.feature-card { \n  background: #fff; \n  border-radius: 12px; \n  padding: 20px 16px; \n  border: 1px solid #edf2f7; \n  box-shadow: 0 4px 12px rgba(0,0,0,.04); \n  transition: all .25s ease; \n  text-align: center;\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.feature-card:hover { \n  transform: translateY(-6px); \n  box-shadow: 0 12px 32px rgba(158,37,54,.15);\n  border-color: rgba(158,37,54,.2);\n}\n\n.feature-card h3 { \n  margin: 12px 0 10px; \n  color: #2d3748; \n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.3;\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.feature-card p { \n  color: #4a5568; \n  line-height: 1.5; \n  font-size: 0.85rem;\n  flex-grow: 1;\n  margin: 0;\n}\n\n.feature-icon { \n  font-size: 2.2rem; \n  margin-bottom: 8px;\n  display: block;\n}\n\n/* 响应式设计 */\n@media (max-width: 1200px) {\n  .features-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n  }\n  \n  .feature-card {\n    min-height: 320px;\n    padding: 24px 20px;\n  }\n  \n  .feature-card h3 {\n    font-size: 1.1rem;\n    min-height: 48px;\n  }\n  \n  .feature-card p {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .features-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .feature-card {\n    min-height: auto;\n    padding: 24px;\n  }\n  \n  .feature-card h3 {\n    font-size: 1.2rem;\n    min-height: auto;\n  }\n  \n  .feature-card p {\n    font-size: 1rem;\n    line-height: 1.6;\n  }\n  \n  .feature-icon {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .features {\n    padding: 60px 0;\n  }\n  \n  .feature-card {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
